import { useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
export default function InputFarsi({
  label,
  Placeholder,
  name,
  defaultValue,
  handelValue,
  disabled,
  dir = 'rtl',
  formGroupStyle = null,
}) {
  const [error, setError] = useState('');
  const [colorerror, setColorerror] = useState('');
  // const pattern = new RegExp(/^[\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u0020\u2000-\u200F\u2028-\u202F\u06A9\u06AF\u06BE\u06CC\u0629\u0643\u0649-\u064B\u064D\u06D5\s]+$/);

  /**
   * این کامپوننت برای اینپوت های فارسی اسصتفاده شده است
   */
  const hedelonCheng = (event) => {
    if (event.target.value) {
      const vlaue = event.target.value;

      // if (pattern.test(vlaue)) {

      if (vlaue.length < 1) {
        setError('اطلاعات را کامل وارد کنید');
        setColorerror('red');
      } else {
        setError('اطلاعات قابل ثبت است');
        setColorerror('green');
        handelValue(name, vlaue);
      }
      // }
      // else {
      //     setError('اطلاعات فقط به فارسی قابل ثبت است')
      //     setColorerror('red')
      // }
    } else {
      setError('');
      setColorerror('');
      handelValue(name, '');
    }
  };

  return (
    <Form.Group style={formGroupStyle}>
      {label ? <Form.Label>{label}</Form.Label> : null}
      <Form.Control
        type='text'
        placeholder={Placeholder ? Placeholder : ''}
        disabled={disabled}
        name={name ? name : ''}
        defaultValue={defaultValue ? defaultValue : ''}
        onChange={hedelonCheng}
        style={{ direction: dir }}
      />
      {!formGroupStyle && error && (
        <Form.Text style={{ color: colorerror }}>{error}</Form.Text>
      )}
    </Form.Group>
  );
}

InputFarsi.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.string,
  /** مقدار هلدر اینپوت است */
  Placeholder: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
};
